import axios from "axios";

const httpService = axios.create({
    headers: { "Content-Type": "application/json", Accept: "application/json" },
});

// helper
const getToken = () => localStorage.getItem("token");


// Request
httpService.interceptors.request.use((config) => {
    if (process.env.NODE_ENV === "development") {
        console.log("📤 Request:", config.method?.toUpperCase(), config.url, config.data);
    }

    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Response
httpService.interceptors.response.use(
    (response) => {
        if (process.env.NODE_ENV === "development") {
            console.log("✅ Response:", response.data);
        }
        return response;
    },
    (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                localStorage.removeItem("token");
            }
        }
        return Promise.reject(error.response);
    }
);

export default httpService;
